'use client';
import BuskerCard from '@/components/BuskerCard';
import { fetchBuskers } from '@/services/supabase-service';
import { useBuskerStore } from '@/store/busker';
import { useState } from 'react';
import { FlatList } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

export default function Buskers() {
  const { buskers, setBuskers } = useBuskerStore();
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const PAGE_SIZE = 10;

  const loadMore = async () => {
    if (!loading && hasMore) {
      console.log('Loading more buskers');
      setLoading(true);
      const newBuskers = await fetchBuskers(PAGE_SIZE, buskers.length);
      setBuskers([...buskers, ...newBuskers]);
      setHasMore(newBuskers.length > 0);
      setLoading(false);
    }
  };

  const [refreshing, setRefreshing] = useState(false);

  const onRefresh = async () => {
    setRefreshing(true);
    setLoading(true);
    const newBuskers = await fetchBuskers(PAGE_SIZE, 0);
    setBuskers(newBuskers);
    setHasMore(newBuskers.length > 0);
    setRefreshing(false);
    setLoading(false);
  };

  return (
    <SafeAreaView className="h-full w-full">
      <FlatList
        contentContainerStyle={{ paddingBottom: 70 }}
        data={buskers}
        renderItem={({ item }) => <BuskerCard key={item.id} busker={item} />}
        keyExtractor={(item) => item.id?.toString() || String(Math.random())}
        onEndReached={loadMore}
        onEndReachedThreshold={0}
        refreshing={refreshing}
        onRefresh={onRefresh}
      />
    </SafeAreaView>
  );
}
